import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import Store from './Store/Store';
import InitSettings from './InitSettings';

const rootElement = document.getElementById('root');
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <React.StrictMode>
            <Provider store={Store}>
                <InitSettings />
            </Provider>
        </React.StrictMode>
    );
}
